<template>
  <el-dialog title="编辑联系人信息" :visible.sync="dialogVisible" width="600px" @close="handleClose">
    <el-form :model="contactForm" :rules="contactRules" ref="contactForm" label-width="120px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="contactForm.name" placeholder="请输入姓名"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="日本名" prop="jp_name">
            <el-input v-model="contactForm.jp_name" placeholder="请输入日本名"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="性别" prop="sex">
            <el-select v-model="contactForm.sex" placeholder="请选择性别">
              <el-option label="女" :value="0"></el-option>
              <el-option label="男" :value="1"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="年龄" prop="age">
            <el-input-number size="small" v-model="contactForm.age" :min="0" :max="150" placeholder="请输入年龄"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="价格" prop="price">
            <el-input-number size="small" v-model="contactForm.price" :min="0" :precision="2" placeholder="请输入价格"></el-input-number>
          </el-form-item>
        </el-col>
      
      </el-row>
       
    </el-form>
    
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="loading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ContactEditDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    contactData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      contactForm: {
        id: null,
        name: '',
        jp_name: '',
        sex: null,
        age: null,
        price: null,
        real_price: null,
        cn_real_price: null,
        status: null,
        back_status: null,
        lang: '',
        charge_str: '',
        charge: null,
        refund_plan_id: null
      },
      contactRules: {
        name: [
          { max: 50, message: '姓名不能超过50个字符', trigger: 'blur' }
        ],
        jp_name: [
          { max: 50, message: '日本名不能超过50个字符', trigger: 'blur' }
        ],
        age: [
          { type: 'number', min: 0, max: 150, message: '年龄必须在0-150之间', trigger: 'blur' }
        ],
        price: [
          { type: 'number', min: 0, message: '价格不能小于0', trigger: 'blur' }
        ],
         
      }
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
    },
    dialogVisible(newVal) {
      if (!newVal) {
        this.$emit('update:visible', false)
      }
    },
    contactData: {
      handler(newData) {
        if (newData && Object.keys(newData).length > 0) {
          this.contactForm = { ...this.contactForm, ...newData }
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
      this.resetForm()
    },
    async handleSubmit() {
      this.$refs.contactForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          try {
            const response = await axios.post(this.base_url + '/orders/contacts/update', this.contactForm)
            console.log('response', response)
            if (response.status === 200 && response.data.code) {
              this.$message.success('联系人信息修改成功')
              this.dialogVisible = false
              
              // 通知父组件更新数据，传递包含order_id的联系人数据
              this.$emit('success', this.contactForm)
            } else {
              this.$message.error(response.data.message || '修改失败')
            }
          } catch (error) {
            console.error('更新联系人失败:', error)
            this.$message.error('更新联系人失败')
          } finally {
            this.loading = false
          }
        } else {
          this.$message.error('请检查表单填写是否正确')
        }
      })
    },
    resetForm() {
      this.$refs.contactForm && this.$refs.contactForm.resetFields()
      this.contactForm = {
        id: null,
        name: '',
        jp_name: '',
        sex: null,
        age: null,
        price: null,
        real_price: null,
        cn_real_price: null,
        status: null,
        back_status: null,
        lang: '',
        charge_str: '',
        charge: null,
        refund_plan_id: null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-footer {
  text-align: right;
}

.el-form {
  .el-select {
    width: 100%;
  }
}
</style>